import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarExtensionConfiguracion } from '../../../actions/configuracion';

const EliminarExtension = ({ extension, reestablecerExtension }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar extension */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarExtensionConfiguracion(extension?._id));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerExtension(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(extension){
            setEliminarModal(true);
        }
    }, [extension]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar extensión</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar la extensión "{extension?.nombre}"{' con ' + extension?.requerimientos + (extension?.requerimientos == 1 ? ' requerimiento relacionado' : ' requerimientos relacionados')}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarExtension;